import { AxiosError } from 'axios';
import Service from 'core/service'

const PAGE_SIZE = 25;
export class DashboardService extends Service {
  async fetchTimeSheetsWithParams(params: any) {
    try {
      return this.get("/TimesheetExpands/GetExpands", params);
    } catch (error) {
      throw error;
    }
  }

  fetchTimeSheetById(id:number, expand?: string, select?: string){
    let params: any = {
    };
    if (expand) {
      params["$expand"] = expand;
    }
    if (select) {
      params["$select"] = select;
    }
    return this.get(`/Timesheet(${id})`, params);
  }

  countTimeSheetByStatus(filter?: string){
    let params: any = {
      $count: true
    };
    params["$top"] = 0
    if (filter) {
      params["$filter"] = filter;
    }
    return this.get("/Timesheet", params);
  }

  fetchTimesheetEvent(expand?: string, filter?: string){
    let params: any = {
      '$orderby': 'TimesheetEventDateTime desc'
    };
    if (expand) {
      params["$expand"] = expand;
    }
    if (filter) {
      params["$filter"] = filter;
    }
    return this.get("/TimesheetEvent", params);
  }
}

